import { tierLabel } from './tiers';
import { ACTION, MONEY, PAGE } from './labels';
const sentenceCase = (s) => (s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : s);
const SUPER_AGENT_ANY_CASE = /\bsuper[ _-]?agent\b/gi;
const PORTAL_USD_TYPE_DISPLAY = {
    Withdraw: 'Withdrawal',
    'Purchase credits': MONEY.buyCredits,
    'Balance Correction — Credit': 'Balance correction (credit)',
    'Balance Correction — Debit': 'Balance correction (debit)',
    'Transaction Reversal': 'Reversal',
};
/** Only the role prefix before ":" or "·" ("Super agent: Ann"), never a display name or username. */
const SUPER_AGENT_ROLE_PREFIX = /^(\s*)super[ _-]?agent(?=\s*[:·])/i;
const portalPartyText = (label) => label.replace(SUPER_AGENT_ROLE_PREFIX, '$1Super Agent');
export const PORTAL_TERMS = {
    variant: 'portal',
    applyFilters: ACTION.apply,
    cash: {
        ledgerTitle: PAGE.cashTransactions,
        ledgerDescription: 'Credits sold for cash in your network, and cash deposits and redemptions at the counter.',
        flowLabel: {
            admin_super_agent: 'Admin → Super Agent',
            super_agent_agent: 'Super Agent → Agent',
            agent_shop: 'Agent → Shop',
            shop_player_deposit: 'Counter deposit (Shop → Player)',
            shop_player_redemption: 'Counter redemption (Player → Shop)',
        },
        flowShortLabel: {
            admin_super_agent: 'Admin → Super Agent',
            super_agent_agent: 'Super Agent → Agent',
            agent_shop: 'Agent → Shop',
            shop_player_deposit: MONEY.counterDeposit,
            shop_player_redemption: MONEY.counterRedemption,
        },
        flowFilterOptions: [
            { value: '', label: 'All' },
            { value: 'admin_super_agent', label: 'Admin → Super Agent' },
            { value: 'super_agent_agent', label: 'Super Agent → Agent' },
            { value: 'agent_shop', label: 'Agent → Shop' },
            { value: 'shop_player_deposit', label: 'Counter deposit (Shop → Player)' },
            { value: 'shop_player_redemption', label: 'Counter redemption (Player → Shop)' },
        ],
        fromColumn: 'From',
        toColumn: 'To',
        searchPlaceholder: 'Transaction ID, name, reference…',
        counterInTitle: MONEY.counterDeposits,
        counterOutTitle: MONEY.counterRedemptions,
        creditWalletSuffix: 'credit wallet',
        sellTitle: { counter: MONEY.depositCredits, hierarchy: MONEY.sellCredits },
        sellSubtitleHierarchy: 'The account you opened is pre-filled.',
        sellSubmit: { counter: MONEY.deposit, hierarchy: MONEY.sellCredits },
        sellCreditsField: 'Credits *',
        sellBuyerBadge: 'To',
        sellInvalidCostRate: 'Cost rate is invalid',
        redeemTitle: MONEY.redeemCredits,
        redeemSubmit: MONEY.redeem,
    },
    credit: {
        typeFilterOptions: [
            { value: 'all', label: 'All' },
            { value: 'deposit', label: 'Credits in' },
            { value: 'withdraw', label: 'Credits out' },
        ],
        summary: { total: 'Total transactions', in: 'Credits in', out: 'Credits out', net: 'Net change' },
        emptyFilteredHint: `Try changing your filters or search, then select ${ACTION.apply}.`,
        partyRole: (roleNoun) => tierLabel(roleNoun) || sentenceCase(roleNoun),
        partyText: portalPartyText,
        typeDisplay: (label) => { var _a; return ((_a = { Deposit: 'Credits in', Withdraw: 'Credits out' }[label]) !== null && _a !== void 0 ? _a : label); },
    },
    usd: {
        typeFilterOptions: [
            { value: 'all', label: 'All types' },
            { value: 'deposit', label: 'Deposit' },
            { value: 'withdrawal', label: 'Withdrawal' },
            { value: 'purchase_credits', label: MONEY.buyCredits },
            { value: 'adjustment', label: 'Adjustment' },
            { value: 'reversal', label: 'Reversal' },
        ],
        summary: { total: 'Total transactions', in: 'Deposits', out: 'Withdrawals', net: 'Net change' },
        ownerRole: (ownerType) => tierLabel(ownerType) || (ownerType ? sentenceCase(ownerType.replace(/_/g, ' ')) : 'Account'),
        activityText: (text) => text
            .replace(/\bbuyer\b/g, 'the buying account')
            .replace(SUPER_AGENT_ANY_CASE, 'Super Agent')
            .replace(/\b(player|agent|shop|cashier)\b/g, (w) => w.charAt(0).toUpperCase() + w.slice(1))
            .replace(/\busd\b/g, 'USD'),
        typeDisplay: (label) => { var _a; return (_a = PORTAL_USD_TYPE_DISPLAY[label]) !== null && _a !== void 0 ? _a : label; },
        partyText: portalPartyText,
    },
};
